import {
  SET_GIFT_CARD_TOTAL_AMOUNT,
  SET_GIFT_CARD_ERROR,
} from "../actions/pdp-actions";
const initialState = {
  total: 0,
  isValid: true,
  errorMessage: null,
};

const giftCards = (state = initialState, action) => {
  switch (action.type) {
    case SET_GIFT_CARD_TOTAL_AMOUNT:
      return {
        ...state,
        total: action.total,
        isValid: action.isValid,
      };
    case SET_GIFT_CARD_ERROR:
      return {
        ...state,
        errorMessage: action.message
          ? {
              text: action.message,
            }
          : null,
      };
    default:
      return state;
  }
};

export default giftCards;
